

/**
 * Display the class item in the planner grid UI
 * @param {} timetableService 
 * @param {} plannerFactory 
 * @param {} $uibModal 
 * @returns {} 
 */
export default function (timetableService, plannerFactory, $uibModal) {

    const classDetailModalTemplate = `
        <div class="modal-header">
           <h3 class="mb-0 h4" id="update-modal-label">{{ ::course.courseCode }} {{ ::course.description }} - {{ ::class.classDesc }}</h3>
        </div>
        <div class="modal-body">
           <div class="alert" ng-if="class.noteText !== null">
                <i class="fal fa-comment-alt-exclamation"></i>
                <div>
                    <p>{{ class.noteText }}</p>    
                </div>
            </div>
           <dl class="dl-columns">
               <dt>Location</dt>
               <dd>{{ class.room }} <span ng-if="class.room !== \'ONLINE\'">({{ class.location }})</span></dd>
               <dt>Day</dt>
               <dd>{{ class.meetingDayNo|dateTime:\'day\' }}</dd>
               <dt ng-if="class.meetingStartTime !== null && class.meetingEndTime !== null && class.room !== \'ONLINE\'">Time</dt>
               <dd ng-if="class.meetingStartTime !== null && class.meetingEndTime !== null && class.room !== \'ONLINE\'">
                    {{ class.meetingStartTime|dateTime:\'time\' }}&ndash;{{ class.meetingEndTime|dateTime:\'time\' }}
                </dd>
               <dt ng-if="all[0].meetingStartDate !== null && all[0].meetingEndDate !== null">Dates</dt>
               <dd ng-if="all[0].meetingStartDate !== null && all[0].meetingEndDate !== null">
                   <span ng-repeat="a in all track by $index">
                       <span>{{ a.meetingStartDate | date:\'d MMMM\' }}&ndash;{{ a.meetingEndDate | date:\'d MMMM\' }}</span><br ng-if="$index < all.length" />
                   </span>
               </dd>
           </dl>
           <p class="footnote">For course requisites and fee information, refer to the <a href="{{ courseDetailHref }}">course detail</a>.</p>
        </div>
        <div class="modal-footer">
           <a class="btn btn-secondary mr-auto" href="{{ courseDetailHref }}">Course detail</a>
           <button class="btn btn-outline-primary" ng-click="close()">Close</button>
        </div>`;

    return {
        scope: {
            classData: '='
        },
        restrict: 'E',
        replace: true,
        template: `
            <div class="class-block height{{ class.duration }} {{ cssClass }}"
                ng-click="showClassDetail()"
                aria-label="Class detail"
                title="Class detail">
                <h6>{{ classData.courseCode }} <span ng-bind="!isOnline ? \' - \' + class.classDesc : \'\'"></span></h6>
                <button class="btn btn-link course-card-btn" stop-event ng-click="removeFromPlanner()" aria-label="Remove from planner" title="Remove from planner">
                    <i class="fal fa-xmark"></i>
                </button>               
                <div ng-if="class.noteText !== null" class="notes-icon" aria-label="Refer to class notes" title="Refer to class notes">
                    <i class="fal fa-info-circle"></i>
                </div>
            </div>`,
        link: function (scope) {

            scope.class = scope.classData.class;

            /**
             * Set the class on the block element, as determined by the properities of the class
             */
            function cssClass() {
                scope.cssClass = [
                    scope.class.room === 'ONLINE' ? 'online' : '',
                    scope.class.clash === 'left' ? 'clash-left' : '',
                    scope.class.clash === 'right' ? 'clash-right' : '',
                    scope.class.red ? 'clash-red' : ''
                ].join(' ').trim();

                scope.isOnline = scope.class.classDesc.toLowerCase().replace(' ', '') === 'online';
            }

            cssClass();

            /**
             * display the modal for the selected class, triggered by clicking the card.
             * fetches all classes for the given course to display in dropdown for adding new class selections
             * @returns {} 
             */
            scope.showClassDetail = function () {

                timetableService.getClasses(scope.class.courseId).then(function (response) {

                    var classes = response.data ? response.data.data : response;

                    const modal = $uibModal.open({
                        template: classDetailModalTemplate,
                        controller: 'ClassDetailModalCtrl',
                        resolve: {
                            c: function () {
                                return scope.classData;
                            },
                            all: function () {
                                return classes.where(function (r) {
                                    return r.classNo === scope.class.classNo && r.meetingDayNo === scope.class.meetingDayNo && r.meetingStartTime === scope.class.meetingStartTime;
                                });
                            }
                        }
                    });

                    // doesn't return anything, but need to manage the closure
                    modal.result.then(() => { }, () => { });
                });
            };

            /**
             * Remove the class from the planner view
             * @returns {} 
             */
            scope.removeFromPlanner = function () {
                plannerFactory.removeFromPlanner(scope.classData, false);
            }

            /**
             * When the planner is updated, the classes on the current class block may need to change
             * Easiest way to do this is subscribe to changes, then fetch the corresponding class from the planner
             * and replace the current with the new, and regenerate the CSS string
             */
            timetableService.subscribe(scope, 'plannerChanged',
                function (e, args) {
                    var inPlanner = args.addedToPlanner;
                    if (inPlanner.length) {
                        var fromPlanner = inPlanner.filter(function (v) {
                            return v.class.classNo === scope.class.classNo;
                        })[0];

                        if (fromPlanner) {
                            scope.classData.class = fromPlanner.class;
                            cssClass();
                        }
                    }
                });
        }
    };
};